import React from "react";
import RateandTerms from "./RateandTerms";

export default function Representative() {
  const loanData = [
    ["Loan Amount", "₹ 50,000"],
    ["Loan Tenure", "12 Months"],
    ["APR", "35%"],
    ["Processing Fee", "₹ 1,000"],
    ["GST on Processing Fee", "₹ 180"],
    ["Monthly EMI", "₹ 4,998"],
    ["Total Interest Payable", "₹ 9,978"],
  ];

  return (
    <section className="w-full py-20 px-4 sm:px-6">
      <RateandTerms />

      

         
    
    </section>
  );
}